module.exports = __webpack_public_path__ + "img/u665b.3844fdef.jpg";